import { Assets, Texture, type AssetsManifest } from "pixi.js";

// Files live in public/ and are copied as-is into dist/. Add more bundles per screen or level.
// They ship with the app, so the game always has art even when OTA content is missing.
export const manifest: AssetsManifest = {
  bundles: [
    {
      name: "main",
      // SVGs are rasterized on load; resolution 2 keeps them sharp on high-DPI screens.
      assets: [{ alias: "coin", src: "images/coin.svg", data: { resolution: 2 } }],
    },
  ],
};

/** The OTA content bundle (from the release's content) whose aliases override the built-in art. */
export const CONTENT_BUNDLE = "main";

export interface GameTextures {
  coin: Texture;
}

/** Picks the content bundle's textures, falling back per alias to the built-in ones. */
export function gameTextures(content: Record<string, unknown> | undefined): GameTextures {
  return { coin: texture(content?.coin) ?? Assets.get<Texture>("coin") };
}

function texture(value: unknown): Texture | undefined {
  return value instanceof Texture && !value.destroyed ? value : undefined;
}
